<template>
  <div>
    <!-- <div class="noOp">{{reversedMessage}}</div> -->
    <whiteList />

    <b-container>
      <b-row>
        <b-col cols="12">
          <collectibles />
          <br>
          <refund />
        </b-col>
      </b-row>
    </b-container>
    <br /><br />
  </div>
</template>

<script>
import Web3 from "web3";
import axios from "axios";
import tokenContractInfo from "../../assets/contracts/newCut.json";
import whiteList from "./whiteList.vue";
import refund from "./refund.vue";
import collectibles from "./collectibles.vue";
import passContractInfo from "../../assets/contracts/passContract.json";

export default {
  name: "StoreProduct",
  components: {
    whiteList,
    refund,
    collectibles
  },
  data: function() {
    return {
      discordInput: "",
      selected: null,
      options: [{ value: "Mutants", text: "Cosmic Mutants" }],

      filter: "All",

      web3: "",

      raffleAmount: 1,

      walletAddress: "",
      walletBalance: "",

      passContract: "",
      passContractAbi: passContractInfo.abi,
      passContractAddress: passContractInfo.contractAddress,

      isApproved: false,

      tokenContract: "",
      tokenContractAbi: tokenContractInfo.abi,
      tokenContractAddress: tokenContractInfo.contractAddress,

      tokenAmount: "",

      fusionGeneratorOpen: false,

      totalRaffles: 0,

      loadingTransaction: false,

      raffleEntries: 0,
      walletsInRaffle: [],

      shouldBeEnabled: true,

      gas: "",

      days: "",
      hours: "",
      minutes: "",
      seconds: "",

      alreadyInDB: false,

      totalProject1: 0,
      totalProject2: 0
    };
  },
  mounted() {
    this.LoadEthWallet();
    axios
      .get(`https://cosmiclabsapi.herokuapp.com/api/contacts`)
      .then(response => {
        var tempArray = [];

        for (var i = 0; i < response.data.data.length; i++) {
          this.walletsInRaffle = response.data.data;
        }

        for (var i = 0; i < response.data.data.length; i++) {
          if (response.data.data[i].whiteListChoice == "Mutants") {
            this.totalProject1++;
          }
          tempArray[i] = response.data.data[i].address;
        }
      })
      .catch(err => {});
  },
  methods: {
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    async buyCoupon() {
      const email = document.getElementById("emailInput").value;
      if (email.includes("@") && email.includes(".")) {
        if (this.tokenAmount >= 500) {
          this.loadingTransaction = true;

          await this.tokenContract.methods
            .burn(
              this.walletAddress,
              this.web3.utils.toWei((500).toString(), "ether")
            )
            .send({ from: this.walletAddress })
            .on("confirmation", function(confirmationNumber, receipt) {})
            .then(confirmed => {
              axios
                .post(`https://cosmiclabsapi.herokuapp.com/api/contacts`, {
                  address: this.walletAddress,
                  discordName: email,
                  whiteListChoice: email
                })
                .then(response => {
                  alert("You will be contacted at " + email);
                  this.loadingTransaction = false;
                })
                .catch(err => {
                  this.loadingTransaction = false;
                });
            })
            .catch(err => {
              this.loadingTransaction = false;
            });
        } else {
          alert("You don't have enough CUT!");
        }
      } else {
        alert("Invalid email!");
      }
    },
    async checkRaffle() {
      this.loadingTransaction = true;
      this.alreadyInDB = false;
      await axios
        .get(`https://cosmiclabsapi.herokuapp.com/api/contacts`)
        .then(response => {
          for (var i = 0; i < response.data.data.length; i++) {
            if (
              (response.data.data[i].address == this.walletAddress ||
                response.data.data[i].discordName == this.discordInput) &&
              response.data.data[i].whiteListChoice == this.selected
            ) {
              this.alreadyInDB = true;
            }
          }
        })
        .catch(err => {});
    },
    async addToDB() {
      await axios
        .post(`https://cosmiclabsapi.herokuapp.com/api/contacts`, {
          address: this.walletAddress,
          discordName: this.discordInput,
          whiteListChoice: this.selected
        })
        .then(response => {})
        .catch(err => {
          this.loadingTransaction = false;
        });
    },
    addToRaffle() {
      this.loadingTransaction = true;
    },
    setSelected(incoming) {
      this.selected = incoming;
    },
    buyGenerator() {
      if (this.tokenAmount >= 700) {
        this.loadingTransaction = true;
        this.passContract.methods
          .FusionGenerator()
          .send({ from: this.walletAddress })
          .on("confirmation", function(confirmationNumber, receipt) {})
          .then(res => {
            alert("You Minted A Fusion Generator!");
            this.LoadTokenInfo();
            this.loadingTransaction = false;
          })
          .catch(err => {
            this.loadingTransaction = false;
          });
      } else {
        alert(
          "You don't have enough (250 Cosmic Tokens) to mint a Baby Alpha Pass"
        );
      }
    },
    buyGenesis() {
      this.passContract.methods
        .balanceOf(this.walletAddress, 1)
        .call({})
        .then(res => {
          if (res >= 1) {
            this.passContract.methods
              .balanceOf(this.walletAddress, 2)
              .call({})
              .then(res => {
                if (res >= 1) {
                  if (this.tokenAmount >= 2500) {
                    this.loadingTransaction = true;
                    this.passContract.methods
                      .GenesisAlphaPass()
                      .send({ from: this.walletAddress })
                      .on("confirmation", function(
                        confirmationNumber,
                        receipt
                      ) {})
                      .then(res => {
                        alert("You Minted A Genesis Alpha Pass!");
                        this.LoadTokenInfo();
                        this.loadingTransaction = false;
                      })
                      .catch(err => {
                        this.loadingTransaction = false;
                      });
                  } else {
                    alert(
                      "You don't have enough (2500 Cosmic Tokens) to mint a Genesis Alpha Pass"
                    );
                  }
                } else {
                  alert(
                    "You must have 2500 Cosmic Tokens, Baby Alpha Pass and a Cosmic Alpha Pass as well!"
                  );
                }
              });
          } else {
            alert(
              "You must have 2500 Cosmic Tokens, Baby Alpha Pass and a Cosmic Alpha Pass as well!"
            );
          }
        });
    },
    buyCosmic() {
      this.passContract.methods
        .balanceOf(this.walletAddress, 1)
        .call({})
        .then(res => {
          if (res >= 1) {
            if (this.tokenAmount >= 1250) {
              this.loadingTransaction = true;
              this.passContract.methods
                .CosmicAlphaPass()
                .send({ from: this.walletAddress })
                .on("confirmation", function(confirmationNumber, receipt) {})
                .then(res => {
                  alert("You Minted A Cosmic Alpha Pass!");
                  this.LoadTokenInfo();
                  this.loadingTransaction = false;
                })
                .catch(err => {
                  this.loadingTransaction = false;
                });
            } else {
              alert(
                "You don't have enough (1250 Cosmic Tokens) to mint a Cosmic Alpha Pass"
              );
            }
          } else {
            alert(
              "You must have 1250 Cosmic Tokens and a Baby Alpha Pass as well!"
            );
          }
        });
    },
    buyBaby() {
      if (this.tokenAmount >= 500) {
        this.loadingTransaction = true;
        this.passContract.methods
          .BabyAlphaPass()
          .send({ from: this.walletAddress })
          .on("confirmation", function(confirmationNumber, receipt) {})
          .then(res => {
            alert("You Minted A Baby Alpha Pass!");
            this.LoadTokenInfo();
            this.loadingTransaction = false;
          })
          .catch(err => {
            this.loadingTransaction = false;
          });
      } else {
        alert(
          "You don't have enough (500 Cosmic Tokens) to mint a Baby Alpha Pass"
        );
      }
    },
    approveTokens() {
      this.loadingTransaction = true;

      this.tokenContract.methods
        .approve(
          this.passContractAddress,
          this.web3.utils.toWei("1000000000", "ether")
        )
        .send({ from: this.walletAddress })
        .on("confirmation", function(confirmationNumber, receipt) {})
        .then(res => {
          alert("You are approved to access the Shop!");
          this.LoadTokenInfo();
          this.loadingTransaction = false;
        })
        .catch(err => {
          this.loadingTransaction = false;
        });
    },
    LoadTokenInfo: function() {
      this.tokenContract = new this.web3.eth.Contract(
        this.tokenContractAbi,
        this.tokenContractAddress
      );
      this.passContract = new this.web3.eth.Contract(
        this.passContractAbi,
        this.passContractAddress
      );

      this.tokenContract.methods
        .balanceOf(this.walletAddress)
        .call({})
        .then(res => {
          this.tokenAmount = this.web3.utils.fromWei(res, "ether");
        });

      this.tokenContract.methods
        .allowance(this.walletAddress, this.passContractAddress)
        .call({})
        .then(res => {
          if (Number(this.web3.utils.fromWei(res, "ether")) > 3000) {
            this.isApproved = true;
          } else {
            this.isApproved = false;
          }
        });

      this.passContract.methods
        .fusionGeneratorOpen(this.walletAddress)
        .call({})
        .then(res => {
          this.fusionGeneratorOpen = res;
        });
    },
    async chainChange() {
      await window.ethereum.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: "0x1" }] // chainId must be in hexadecimal numbers
      });
      this.LoadEthWallet();
    },
    LoadEthWallet: function() {
      if (typeof window.ethereum !== "undefined") {
        ethereum.enable();
        this.web3 = new Web3(
          this.walletConnect ||
            window.ethereum ||
            new Web3.providers.HttpProvider(
              "https://mainnet.infura.io/v3/1xVMLkEDl6htSmYN7YeFXGvIe07"
            ) ||
            Web3.givenProvider
        );
        this.web3.eth.net.getNetworkType().then(network => {
          if (network == "main") {
            this.web3.eth
              .requestAccounts()
              .then(acc => {
                this.walletAddress = acc[0];
                this.web3.eth.getBalance(this.walletAddress).then(balance => {
                  this.walletBalance = this.web3.utils.fromWei(
                    balance,
                    "ether"
                  );
                  this.LoadTokenInfo();
                });
              })
              .catch(err => {
                console.log(err);
              });
          } else {
            this.chainChange();
          }
        });
      }
    }
  },
  watch: {
    walletAddress: function(val) {
      window.ethereum.on("accountsChanged", accounts => {
        if (accounts.length > 0) {
          this.walletAddress = accounts[0];
          this.web3.eth.getBalance(this.walletAddress).then(balance => {
            this.walletBalance = this.web3.utils.fromWei(balance, "ether");
          });
          this.LoadTokenInfo();
        } else {
          this.walletAddress = "";
          this.walletBalance = "";
        }
      });
    },
    walletBalance: function(val) {
      window.ethereum.on("balanceChanged", balance => {
        this.walletBalance = balance;
        this.LoadTokenInfo();
      });
    }
  },
  computed: {
    reversedMessage: function() {
      var countDownDate = new Date(1638579600 * 1000).getTime();
      var globalClock = this;
      setInterval(
        function() {
          var now = new Date().getTime();
          var timeleft = countDownDate - now;

          var days = Math.floor(timeleft / (1000 * 60 * 60 * 24));
          if (days < 10) {
            globalClock.days = "0" + days;
          } else globalClock.days = days;
          if (days < 0) globalClock.days = 0;
          var hours = Math.floor(
            (timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
          );
          if (hours < 10) {
            globalClock.hours = "0" + hours;
          } else globalClock.hours = hours;
          if (hours < 0) globalClock.hours = 0;
          var minutes = Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60));
          if (minutes < 10) {
            globalClock.minutes = "0" + minutes;
          } else globalClock.minutes = minutes;
          if (minutes < 0) globalClock.minutes = 0;
          var seconds = Math.floor((timeleft % (1000 * 60)) / 1000);
          if (seconds < 10) {
            globalClock.seconds = "0" + seconds;
          } else globalClock.seconds = seconds;
          if (seconds < 0) globalClock.seconds = 0;
          if (countDownDate - now > 0) {
            globalClock.shouldBeEnabled = true;
          } else globalClock.shouldBeEnabled = false;
        },
        1000,
        this
      );
      return (
        this.days +
        " : " +
        this.hours +
        " : " +
        this.minutes +
        " : " +
        this.seconds
      );
    }
  }
};
</script>

<style scoped>
.cardShirt {
  border: 4px solid #5e5df0;
}
.cardShirtMobile {
  width: 100% !important;
  border: 4px solid #5e5df0;
}
.shirt {
  width: 100%;
}
.proj {
  width: 30vh;
  height: auto;
}
.selectText {
  color: #c400ff;
}
.selectTextSmaller {
  color: #c400ff;
  font-size: 2vh;
}
.selectedName {
  color: white;
}
.displayItem {
  width: 25%;
}
.walletAddress {
  font-size: 2vh;
}
.cardDiv {
  width: 100% !important;
}
.scrollCard {
  max-height: 25vh;
  overflow-y: auto;
  background: transparent;
  color: white;
  width: 70% !important;
}
.hrStyle {
  border: 0;
  height: 1px;
  width: 100%;
  background-image: linear-gradient(to right, white, white, white);
}

.noOp {
  opacity: 0;
}
.wallet {
  color: white;
  font-size: 2vh;
}
.label {
  color: white;
}
.collection-sort {
  padding: 5vh;
}
.card {
  width: 30%;
  display: inline-block;
  margin-top: 0.5vh;
  margin-bottom: 0.5vh;
}

.token {
  width: 10%;
}

.temp {
  opacity: 0;
}

.pass {
  width: 100%;
}

.mobileCard {
  width: 100% !important;
}

.gradient {
  background: linear-gradient(90deg, #c400ff 0%, #78009f 100%);
}

.css-t6n5l8 {
  box-sizing: border-box;
  margin: 0;
  min-width: 0;
  -webkit-appearance: none;
  -moz-appearance: none;
  -ms-appearance: none;
  appearance: none;
  display: inline-block;
  text-align: center;
  line-height: inherit;
  -webkit-text-decoration: none;
  text-decoration: none;
  font-size: inherit;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: white;
  border: 0;
  border-radius: 4px;
  cursor: pointer;
  background: linear-gradient(90deg, #c400ff 0%, #78009f 100%);
  font-size: 0.875rem;
  text-align: center;
  font-weight: 500;
  border-radius: 0px;
  padding-left: 2.78em;
  padding-right: 2.78em;
  padding-top: 0.61em;
  padding-bottom: 0.61em;
  -webkit-transition: 0.3s ease-in-out;
  transition: 0.3s ease-in-out;
}

.timer {
  color: #c400ff;
}

.ticket {
  position: absolute;
  width: 3%;
  top: 30%;
  left: 45%;
}

/* CSS */
.button-42 {
  background-color: initial;
  background-image: linear-gradient(-180deg, #eca0f2, #d273ed);
  border-radius: 6px;
  box-shadow: rgba(0, 0, 0, 0.1) 0 2px 4px;
  color: #ffffff;
  cursor: pointer;
  display: inline-block;
  font-family: Inter, -apple-system, system-ui, Roboto, "Helvetica Neue", Arial,
    sans-serif;
  height: 40px;
  line-height: 40px;
  outline: 0;
  overflow: hidden;
  padding: 0 20px;
  pointer-events: auto;
  position: relative;
  text-align: center;
  touch-action: manipulation;
  user-select: none;
  -webkit-user-select: none;
  vertical-align: top;
  white-space: nowrap;
  width: 100%;
  z-index: 9;
  border: 0;
  transition: box-shadow 0.2s;
}

.button-42:hover {
  box-shadow: #b833e8 0 3px 8px;
}

.emailInput {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Store/storeProduct.vue